import { ExperienceCommentsModel } from "./experience-comments.model";
import { ExperienceEvaluationsModel } from "./experience-evaluations.model";

export class ExperienceModel{
    id?: number;
    travelerName    ?: string;
    travelerImage   ?: string;
    travelerId      ?: number;
    title           ?: string;
    description     ?: string;
    videoUrl        ?: string;
    date            ?: Date;
    numberOfComments?: number;
    numberOfStars   ?: number;
    comments        ?:ExperienceCommentsModel[];
    evaluations     ?:ExperienceEvaluationsModel[];
    embedServiceHtml ?: any;
    constructor(item ?: ExperienceModel){
        item = item ? item : {};
        this.id = item.id ? item.id : 0;
        this.embedServiceHtml     = item.embedServiceHtml     ? item.embedServiceHtml     : null;
        this.travelerName     = item.travelerName     ? item.travelerName     : '';
        this.travelerImage    = item.travelerImage    ? item.travelerImage    : '';
        this.travelerId       = item.travelerId       ? item.travelerId       : 0;
        this.title            = item.title            ? item.title            : '';
        this.description      = item.description      ? item.description      : '';
        this.videoUrl         = item.videoUrl         ? item.videoUrl         : '';
        this.date             = item.date             ? item.date             : null;
        this.numberOfComments = item.numberOfComments ? item.numberOfComments : 0;
        this.numberOfStars    = item.numberOfStars    ? item.numberOfStars    : 0;
        this.comments         = item.comments         ? item.comments         : [];
        this.evaluations      = item.evaluations      ? item.evaluations      : [];

    }
}